import React from 'react';

import SelectAsync from 'react-select/async'
import { components } from "react-select"
import Icon from '@mdi/react'
import { mdiChevronDown } from '@mdi/js'
import { inputStyles } from './Constants'
import styles from './BrandingSelector.module.css';
import I18N from '../classes/I18N'
import translations from '../lang/components/BrandingSelector.lang.json'

const DropdownIndicator = props => {
    return (
      <components.DropdownIndicator {...props}>
        <Icon path={mdiChevronDown} size={1} />
      </components.DropdownIndicator>
    );
};

const i18n = new I18N(translations);

class BrandingSelector extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            options: [
                {
                    selected: true,
                    value: "agent"
                },
                {
                    selected: false,
                    value: "coagent"
                },
                {
                    selected: false,
                    value: "team"
                },
                {
                    selected: false,
                    value: "brokerage"
                },
                {
                    selected: false,
                    value: "unbranded"
                }
            ],
            agent: this.props.preload ? this.props.preloadedAgent : null,
            coagent: this.props.preload ? this.props.preloadedCoAgent : null,
            team: this.props.preload ? this.props.preloadedTeam : null,
            brokerage: this.props.preload ? this.props.preloadedBrokerage : null,
            brand: this.props.preload ? this.props.preloadedBrand : null,
            loadingBrands: true,
            hasAdditionalBrands: true,
        }

        this.switchTab = this.switchTab.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleCoagentChange = this.handleCoagentChange.bind(this);
        this.handleTeamChange = this.handleTeamChange.bind(this);
    }

    componentDidMount() {
        this.getBrandingData(this.props.listing);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.listing?.mlsid && prevProps.listing?.mlsid !== this.props.listing?.mlsid) {
            this.getBrandingData(this.props.listing)
        }

        if (this.props.listing?.manual && this.state.agent?.id !== this.props.authenticatedUser?.id) {
            this.handleChange(this.props.authenticatedUser);
        }
    }

    loadUsers = (search) => {
        if(search.length > 2) {
            return fetch(`${process.env.REACT_APP_KVCORE_API_URI}/user/agents?query=${search}&scopedOnly=0`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${this.props.jwt}`
                }
            }).then(response => response.json()).then(data => data)
        }
    };

    loadTeams = (search) => {
        if(search.length > 0) {
            return fetch(`${process.env.REACT_APP_KVCORE_API_URI}/teams/table?search=${search}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${this.props.jwt}`
                }
            }).then(response => response.json()).then(data => data.data)
        }
    }

    loadBrands = () => {
        this.setState({ loadingBrands: true });

        return fetch(`${process.env.REACT_APP_KVCORE_API_URI}/v2/internal/clm/brands?template_id=${this.props.templateId}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${this.props.jwt}`
            }
        })
        .then(response => response.json())
        .then((data) => {
            // Select the company brand by default
            const companyBrand = data.find((brand) => brand.id === 1);

            if (this.props.preload && this.props.preloadedBrand) {
                this.handleBrandChange(this.props.preloadedBrand);
            } else if (companyBrand) {
                this.handleBrandChange(companyBrand);
            } else if (data.length > 0) {
                // If no "My Company" brand exists, select the first brand in the array
                this.handleBrandChange(data[0]);
            }

            const hasAdditionalBrands = companyBrand ? data.length > 1 : data.length > 0;

            this.setState({ hasAdditionalBrands, loadingBrands: false });

            // return the array of available brands
            return data;
        }).catch((error) => { console.log('error:', error);});
    }

    getBrandLabel = (brand) => {
        if (this.props.locale !== 'rlp') {
            return brand.name;
        }

        const translatedBrands = ['My Company', 'Carriage Trade'];

        if (translatedBrands.includes(brand.name)) {
            return i18n.t(this.props.locale, brand.name);
        }

        return brand.name;
    }

    getBrandingData = (listing) => {
        if (this.props.preload) {
            const scope = this.props.preloadedScope.value;
            const scopeIndices = {
                agent: 0,
                coagent: 1,
                team: 2,
                brokerage: 3,
                unbranded: 4
            };

            // Select the appropriate branding tab, based on the preloaded scope
            this.switchTab(scopeIndices[scope]);

            // Map branding options to their corresponding handlers
            const handlers = {
                agent: 'handleChange',
                coagent: 'handleCoagentChange',
                team: 'handleTeamChange',
                brokerage: 'handleBrokerageChange'
            }

            // Map branding options to their corresponding preloaded props
            const propValues = {
                agent: 'preloadedAgent',
                coagent: 'preloadedCoAgent',
                team: 'preloadedTeam',
                brokerage: 'preloadedBrokerage'
            }

            if (scope !== 'unbranded') {
                // If we're on CoAgent branding, call the appropriate handler to set the Agent as well
                if (scope === 'coagent') {
                    this.handleChange(this.props.preloadedAgent);
                }

                // Call the handler for the selected preloaded branding scope, passing the selected preloaded branding value
                this[handlers[scope]](this.props[propValues[scope]]);
            }
        } else {
            this.handleChange(this.props.authenticatedUser);

            if (listing?.brokerid && listing?.brokerid !== '') {
                fetch(
                    `${process.env.REACT_APP_KVCORE_API_URI}/v2/internal/clm/marketing/templates/brokerage-info?brokerid=${listing.brokerid}`,
                    {
                        method: 'GET',
                        headers: {
                            'Authorization': `Bearer ${this.props.jwt}`
                        }
                }).then(res => res.json()).then(data => {
                    if (data?.entity) {
                        this.setState({team: data.entity});
                        this.handleTeamChange(this.state.team);
                    }

                    if (data?.account) {
                        this.setState({brokerage: data.account});
                        this.handleBrokerageChange(this.state.brokerage);
                    }
                }).catch(err => {
                    console.log(err)
                })
            }
        }
    }

    handleChange = (newValue) => {
        this.props.onAgentChange(newValue);
        this.setState({agent: newValue});
    }

    handleCoagentChange = (newValue) => {
        this.props.onCoagentChange(newValue);
        this.setState({coagent: newValue});
    }

    handleTeamChange = (newValue) => {
        this.props.onTeamChange(newValue);
        this.setState({team: newValue});
    }

    handleBrokerageChange = (newValue) => {
        this.props.onBrokerageChange(newValue);
    }

    handleBrandChange = (newValue) => {
        this.props.onBrandChange(newValue);
        this.setState({brand: newValue});
    }

    switchTab = (index, e) => {
        let options = this.state.options;
        let newState = [];

        options.forEach((item, x) => {
            newState[x] = item;
            newState[x].selected = index === x;
        });

        this.setState({options: newState});
        this.props.onScopeChange(newState[index]);
    }

    agentSelector = () => {
        return (this.state.options[0].selected || this.state.options[1].selected) ?
        (<SelectAsync
            classNamePrefix="react-select"
            components={{DropdownIndicator}}
            placeholder={i18n.t(this.props.locale, 'agent')}
            noOptionsMessage={ () => i18n.t(this.props.locale, 'noOptions') }
            loadingMessage={ () => i18n.t(this.props.locale, 'loading') }
            getOptionLabel={(option) => `${option.full_name}`}
            getOptionValue={(option) => option.id}
            value={this.state.agent}
            loadOptions={this.loadUsers}
            onChange={this.handleChange}
            styles={inputStyles}
        />) :
        ('');
    }

    coAgentSelector = () => {
        return this.state.options[1].selected ?
        (<div className={styles.coagentSelectorContainer}><SelectAsync
            components={{DropdownIndicator}}
            placeholder={i18n.t(this.props.locale, 'coagent')}
            noOptionsMessage={ () => i18n.t(this.props.locale, 'noOptions') }
            loadingMessage={ () => i18n.t(this.props.locale, 'loading') }
            getOptionLabel={(option) => `${option.full_name}`}
            getOptionValue={(option) => option.id}
            value={this.state.coagent}
            loadOptions={this.loadUsers}
            onChange={this.handleCoagentChange}
            styles={inputStyles}
        /></div>) :
        ('');
    }

    teamSelector = () => {
        const shouldRenderDropdown =
            this.state.options[2].selected &&
            (this.props.authenticatedUser?.company_admin ||
            (this.props.authenticatedUser?.adminInfo?.isTeamMember || this.props.authenticatedUser?.adminInfo?.isTeamAdmin));

        return  shouldRenderDropdown ?
        (
            <SelectAsync
                classNamePrefix="react-select"
                components={{DropdownIndicator}}
                placeholder={i18n.t(this.props.locale, 'team')}
                noOptionsMessage={ () => i18n.t(this.props.locale, 'noOptions') }
                loadingMessage={ () => i18n.t(this.props.locale, 'loading') }
                getOptionLabel={(option) => {
                   return option.name_with_vanity ? `${option.name_with_vanity}` : `${option.name}`
                }}
                getOptionValue={(option) => option.id}
                value={this.state.team}
                loadOptions={this.loadTeams}
                onChange={this.handleTeamChange}
                styles={inputStyles}
            />
        ) : ('');
    }

    brandSelector = () => {
        return (
            <SelectAsync
                classNamePrefix="react-select"
                components={{DropdownIndicator}}
                noOptionsMessage={ () => i18n.t(this.props.locale, 'noOptions') }
                loadingMessage={ () => i18n.t(this.props.locale, 'loading') }
                getOptionLabel={ (option) => this.getBrandLabel(option) }
                getOptionValue={(option) => option.id}
                value={this.state.brand}
                loadOptions={this.loadBrands}
                defaultOptions={true}
                onChange={this.handleBrandChange}
                styles={inputStyles}
            />
        )
    }

    render() {
        return (
            <div>
                <div className={styles.brandingSectionHeader}>
                    <div className={styles.brandingIconContainer}>
                        <svg className={"icons-color"} style={{alignSelf: "center"}} width="20" height="17" viewBox="0 0 22 18" stroke="currentColor" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path d="M21.0834 0.375H0.916748V17.625H21.0834V0.375ZM19.2501 15.7083H11.0001V9.95833H19.2501V15.7083Z"/>
                        </svg>
                    </div>
                    <div className={styles.brandingSectionTitle}>
                        {i18n.t(this.props.locale, 'branding')}
                    </div>
                </div>
                {this.state.hasAdditionalBrands
                ? (<div className={this.state.loadingBrands ? styles.hidden : ''}>
                    <div className={styles.fieldLabel}>
                        {i18n.t(this.props.locale, 'brand')}
                    </div>
                    <div className={styles.brandSelectContainer}>
                        {this.brandSelector()}
                    </div>
                </div>)
                : ('')
                }
                <div className={styles.fieldLabel}>
                    {i18n.t(this.props.locale, 'entity')}
                </div>
                <div className={styles.brandingButtonsContainer}>
                    {this.state.options.map((item, index)  => (<button onClick={(e) => this.switchTab(index, e)} className={
                        `${item.selected ? `active ${styles.brandingButton}` : styles.brandingButton}`
                    } key={item.value} disabled={this.props.disabledOptions.includes(item.value)}>{i18n.t(this.props.locale, item.value)}</button>))}
                </div>

                {this.agentSelector()}
                {this.teamSelector()}
                {this.coAgentSelector()}

                <p className={styles.brandingDisclaimer}>{i18n.t(this.props.locale, 'disclaimer')}</p>
            </div>
        );
    }
}

export default BrandingSelector;
